import React, { FC, useState } from 'react'
import Autocomplete from '../autocomplete'
import useDebounce from 'src/shared/hooks/useDebounce'
import { useCreateTaskHashtagMutation, useGetTaskHashtagQuery } from '../../../old-app/service/Tasks'

interface IProps {
	value: any
	placeholder?: string
	onChange: (value: any) => void
	isIds?: boolean
	projectId?: string
	hasCreate: boolean
}

const TaskTagsChoice: FC<IProps> = (p) => {
	const { value, onChange, placeholder = 'Теги', isIds, projectId, hasCreate = true } = p

	const [search, setSearch] = useState<string>('')
	const [createHashtag, result] = useCreateTaskHashtagMutation()
	const debounceSearch = useDebounce(search, 300)

	const { data: taskTagsData } = useGetTaskHashtagQuery({
		hashtag: debounceSearch,
		current_page: 1,
		per_page: 50,
		project_id: projectId,
	})

	const list: any[] = taskTagsData?.data ?? []

	const onInputChange = (event: React.SyntheticEvent, value: string, reason: string) => {
		setSearch(value)
	}

	const createHandler = async (value: any) => {
		const tagData: any = await createHashtag({ hashtag: value.inputValue, project_id: projectId })
		const tag = tagData?.data
		return tag
	}

	return (
		<Autocomplete
			placeholder={placeholder}
			create={hasCreate ? createHandler : undefined}
			// TODO: Вынести в отдельную функцию
			optionLabel={(option: any) => option?.hashtag}
			renderOptionLabel={(option: any) => option?.hashtag}
			list={list}
			onInputChange={onInputChange}
			value={value}
			onChange={onChange}
		/>
	)
}

export default TaskTagsChoice
